document.addEventListener("DOMContentLoaded", function () {
  var containers = document.querySelectorAll(".metafield-rich_text_field");

  containers.forEach(function (container) {
    // Prevent double conversion
    if (container.querySelector("table")) return;

    var paragraphs = Array.from(container.querySelectorAll("p"));
    if (paragraphs.length < 2) return;

    // Check format: must contain " - "
    if (!paragraphs[0].textContent.includes(" - ")) return;

    var rows = paragraphs.map(function (p) {
      return p.textContent.split(" - ").map(function (cell) {
        return cell.trim();
      });
    });

    var table = document.createElement("table");
    table.className = "size-chart-table";
    table.style.borderCollapse = "collapse";
    table.style.width = "100%";
    table.style.marginTop = "10px";

    var tbody = document.createElement("tbody");

    rows.forEach(function (row) {
      var tr = document.createElement("tr");

      row.forEach(function (cell) {
        var td = document.createElement("td");
        td.textContent = cell;
        td.style.border = "1px solid #ccc";
        td.style.padding = "6px";
        td.style.textAlign = "center";
        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    container.innerHTML = "";
    container.appendChild(table);
  });
});
